import { useContext } from "react";
import { RootContext } from "../RootContext";

const useBranding = () => useContext(RootContext).brandingStore;

export default useBranding;
